<div class="brt-rte"
     [class.brt-rte--disabled]="disabled"
     [class.brt-rte--readonly]="readonly"
     [class.brt-rte--error]="hasError">

  <div class="brt-rte__toolbar"
       role="toolbar"
       aria-label="Textformatierung"
       aria-orientation="horizontal"
       [attr.aria-controls]="contentId">

    <button type="button" class="brt-rte__button"
            [class.brt-rte__button--active]="state.bold"
            [attr.aria-pressed]="state.bold"
            [attr.tabindex]="activeButton === 0 ? 0 : -1"
            [disabled]="disabled"
            title="Fett (Strg+B)"
            (mousedown)="preserveSelection($event)"
            (keydown)="onToolbarKeydown($event, 0, 9)"
            (click)="run('bold')">
      <span class="icon icon-text-bold" aria-hidden="true"></span>
      <span class="brt-rte__button-label">Fett</span>
    </button>

    <button type="button" class="brt-rte__button"
            [class.brt-rte__button--active]="state.italic"
            [attr.aria-pressed]="state.italic"
            [attr.tabindex]="activeButton === 1 ? 0 : -1"
            [disabled]="disabled"
            title="Kursiv (Strg+I)"
            (mousedown)="preserveSelection($event)"
            (keydown)="onToolbarKeydown($event, 1, 9)"
            (click)="run('italic')">
      <span class="icon icon-text-italic" aria-hidden="true"></span>
      <span class="brt-rte__button-label">Kursiv</span>
    </button>

    <button type="button" class="brt-rte__button"
            [class.brt-rte__button--active]="state.ul"
            [attr.aria-pressed]="state.ul"
            [attr.tabindex]="activeButton === 2 ? 0 : -1"
            [disabled]="disabled"
            title="Aufzählung"
            (mousedown)="preserveSelection($event)"
            (keydown)="onToolbarKeydown($event, 2, 9)"
            (click)="run('ul')">
      <span class="icon icon-index" aria-hidden="true"></span>
      <span class="brt-rte__button-label">Aufzählung</span>
    </button>

    <button type="button" class="brt-rte__button"
            [class.brt-rte__button--active]="state.ol"
            [attr.aria-pressed]="state.ol"
            [attr.tabindex]="activeButton === 3 ? 0 : -1"
            [disabled]="disabled"
            title="Nummerierte Liste"
            (mousedown)="preserveSelection($event)"
            (keydown)="onToolbarKeydown($event, 3, 9)"
            (click)="run('ol')">
      <span class="icon icon-list" aria-hidden="true"></span>
      <span class="brt-rte__button-label">Nummerierte Liste</span>
    </button>

    <span class="brt-rte__separator" aria-hidden="true"></span>

    <button type="button" class="brt-rte__button"
            [class.brt-rte__button--active]="state.link"
            [attr.aria-pressed]="state.link"
            [attr.tabindex]="activeButton === 4 ? 0 : -1"
            [disabled]="disabled"
            data-rte-link-toggle
            title="Link einfügen (Strg+K)"
            (mousedown)="preserveSelection($event)"
            (keydown)="onToolbarKeydown($event, 4, 9)"
            (click)="run('link')">
      <span class="icon icon-link" aria-hidden="true"></span>
      <span class="brt-rte__button-label">Link einfügen</span>
    </button>

    <button type="button" class="brt-rte__button"
            [attr.tabindex]="activeButton === 5 ? 0 : -1"
            [attr.aria-disabled]="!state.link"
            [disabled]="disabled"
            title="Link entfernen"
            (mousedown)="preserveSelection($event)"
            (keydown)="onToolbarKeydown($event, 5, 9)"
            (click)="run('unlink')">
      <svg class="brt-rte__svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M9.5 14.5 7 17a3.5 3.5 0 0 1-5-5l2.5-2.5" />
        <path d="M14.5 9.5 17 7a3.5 3.5 0 0 1 5 5l-2.5 2.5" />
        <path d="M4 4l16 16" />
      </svg>
      <span class="brt-rte__button-label">Link entfernen</span>
    </button>

    <button type="button" class="brt-rte__button"
            [attr.tabindex]="activeButton === 6 ? 0 : -1"
            [disabled]="disabled"
            title="Formatierung entfernen (Strg+\)"
            (mousedown)="preserveSelection($event)"
            (keydown)="onToolbarKeydown($event, 6, 9)"
            (click)="run('clear')">
      <svg class="brt-rte__svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M7 6h10" />
        <path d="M12 6v9" />
        <path d="M15.5 16.5l5 5" />
        <path d="M20.5 16.5l-5 5" />
      </svg>
      <span class="brt-rte__button-label">Formatierung entfernen</span>
    </button>

    <span class="brt-rte__separator" aria-hidden="true"></span>

    <button type="button" class="brt-rte__button"
            [attr.tabindex]="activeButton === 7 ? 0 : -1"
            [attr.aria-disabled]="!state.canUndo"
            [disabled]="disabled"
            title="Rückgängig (Strg+Z)"
            (mousedown)="preserveSelection($event)"
            (keydown)="onToolbarKeydown($event, 7, 9)"
            (click)="run('undo')">
      <svg class="brt-rte__svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M9 14 4 9l5-5" />
        <path d="M4 9h8a6 6 0 0 1 0 12H8" />
      </svg>
      <span class="brt-rte__button-label">Rückgängig</span>
    </button>

    <button type="button" class="brt-rte__button"
            [attr.tabindex]="activeButton === 8 ? 0 : -1"
            [attr.aria-disabled]="!state.canRedo"
            [disabled]="disabled"
            title="Wiederholen (Umschalt+Strg+Z)"
            (mousedown)="preserveSelection($event)"
            (keydown)="onToolbarKeydown($event, 8, 9)"
            (click)="run('redo')">
      <svg class="brt-rte__svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M15 14l5-5-5-5" />
        <path d="M20 9h-8a6 6 0 0 0 0 12h4" />
      </svg>
      <span class="brt-rte__button-label">Wiederholen</span>
    </button>
  </div>

  <div class="brt-rte__body">
    <div #content
         class="brt-rte__content"
         [id]="contentId"
         role="textbox"
         aria-multiline="true"
         spellcheck="true"
         [attr.contenteditable]="disabled || readonly ? 'false' : 'true'"
         [attr.tabindex]="disabled ? -1 : 0"
         [attr.aria-labelledby]="labelId || null"
         [attr.aria-label]="labelId ? null : (ariaLabel || null)"
         [attr.aria-disabled]="disabled ? 'true' : null"
         [attr.aria-readonly]="readonly ? 'true' : null"
         [attr.aria-invalid]="hasError ? 'true' : null"></div>

    <div class="brt-rte__placeholder" aria-hidden="true" *ngIf="state.empty">{{ placeholder }}</div>

    <div #linkBubble
         class="brt-rte__link-bubble"
         role="group"
         aria-label="Link bearbeiten"
         *ngIf="linkBubbleOpen"
         [style.top.px]="linkBubbleTop"
         [style.left.px]="linkBubbleLeft"
         (keydown)="onBubbleKeydown($event)">
      <input #linkInput
             type="url"
             class="brt-rte__link-input"
             placeholder="https://..."
             aria-label="Adresse"
             [class.brt-rte__link-input--invalid]="linkInvalid"
             [(ngModel)]="linkDraft" />
      <button type="button" class="brt-rte__link-action" (click)="confirmLink()">
        {{ linkBubbleEditing ? 'Ändern' : 'Einfügen' }}
      </button>
      <button type="button" class="brt-rte__link-action" *ngIf="linkBubbleEditing"
              (click)="removeCurrentLink()">Entfernen</button>
      <button type="button" class="brt-rte__link-action" (click)="closeLinkBubble()">Abbrechen</button>
      <p class="brt-rte__link-error" role="alert" *ngIf="linkInvalid">
        Bitte eine gültige Adresse eingeben.
      </p>
    </div>
  </div>

</div>
